import firebase from "firebase/app";

const config = {
  apiKey: "AIzaSyDIMUmvLVQHX9ac4nxgErH4sRL35LTXnxM",
  authDomain: "musicbot-b71b6.firebaseapp.com",
  databaseURL: "https://musicbot-b71b6.firebaseio.com",
  projectId: "musicbot-b71b6",
  storageBucket: "musicbot-b71b6.appspot.com",
  messagingSenderId: "338120021997",
  appId: "1:338120021997:web:e132089440b3ecc30f79e4"
};

firebase.initializeApp(config);
export default firebase;
